module.exports = __webpack_public_path__ + "img/santai_selected.ad3dd2a2.png";